import { baseURL } from "../utilits/config";
import axios from "axios";
import QueryString from "qs";

export function addAssigment(assigmentData, callback){
     const data = QueryString.stringify(assigmentData)
     const config = {
        method: "post",
        url : baseURL + "/assigment",
        headers : {
            "Content-Type" : "application/x-www-form-urlencoded",
        },
        data : data
     };

     axios(config)
        .then((result) => {
            callback(result.data);
        })
        .catch((error) =>{
            callback(error);
        })
}

export function getAssigment(callback){
     const config = {
        method: "get",
        url : baseURL + "/assigment",
        headers : {},
     };

     axios(config)
        .then((result) =>{
             callback(result.data);
        })
        .catch((error) =>{
             callback(error);
        })
}

export function getAssigmentBySeriveID(serviceID, callback){
    const config = {
         method: "get",
         url : baseURL + "/getassignmentBYServiceID?serviceID=" + serviceID,
         headers : {},
    }

    axios(config)
         .then((result) =>{
              callback(result.data);
         })
         .catch((error) => {
            callback(error);
         })
}